import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { Spin, Select, message, Tooltip } from 'antd';
import { PCB_PRE_LAYOUT } from "@/constants/treeConstants";
import {
  updateCanvasStatus,
  updateComponents,
  updateSchematicLoading,
  updateCanvasConfig,
  updatePreLayoutData,
  changePreLayoutMode,
  saveModel
} from "../../../store/prelayout/action";
import Canvas from "./schematicCanvas";
import { updateLibraryTree } from "../../../store/library/action";
import { getPanelMaxHeight, getPanelMaxWidth } from "../../../../../services/helper/panelSizeHelper";
import { PRE_MODEL, PRE_TEMPLATE, SCHEMATIC_GRID_SIZE } from "../../../../../services/Sierra/prelayout/Schematic";
import sierraLibrary from "../../../../../services/Sierra/library/libraryStorage";
import { PCB_SPICE, PCB_TOUCHSTONE, GENERIC_SPICE, GENERIC_TOUCHSTONE, SPICE, TOUCHSTONE } from "../../../../../constants/libraryConstants";
import ModelSelect from "../modelSelect";
import { getLibraryConnectorFile, getTouchstoneParse } from "../../../../../services/Sierra/library";
import { InfoCircleOutlined } from '@ant-design/icons';
import './index.css'

class SchematicSetup extends Component {

  constructor(props) {
    super(props);
    const pcbSpiceList = sierraLibrary.getTree(PCB_SPICE);
    const pcbTouchstoneList = sierraLibrary.getTree(PCB_TOUCHSTONE);
    const genericSpiceList = sierraLibrary.getTree(GENERIC_SPICE);
    const genericTouchstoneList = sierraLibrary.getTree(GENERIC_TOUCHSTONE);
    this.state = {
      width: 1000,
      height: 800,
      isReset: false,
      maxWidth: 1000,
      maxHeight: 800,
      pcbSpiceList,
      pcbTouchstoneList,
      genericSpiceList,
      genericTouchstoneList,
      portsObj: {},
      lastOpenModel: {},
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount() {
    this.getDefaultPorts();
    this.getCanvasWidth(true);
    window.addEventListener('resize', this.getCanvasWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getCanvasWidth);
  }

  componentDidUpdate = (prevProps) => {
    const { id, loading, viewList, libraryTreeInfo, initLibraryStatus } = this.props;
    if (id !== prevProps.id || ((!prevProps.viewList || !prevProps.viewList.includes(PCB_PRE_LAYOUT)) && viewList.includes(PCB_PRE_LAYOUT))) {
      this.getCanvasWidth(true);
      this.getDefaultPorts();
    }

    if (loading !== prevProps.loading) {
      this.getCanvasWidth(true)
    }

    if (libraryTreeInfo && libraryTreeInfo.length && (!prevProps.libraryTreeInfo || libraryTreeInfo.length !== prevProps.libraryTreeInfo.length)) {
      this.getLibraryList(libraryTreeInfo)
      this.props._updateLibraryTree(null);
    }

    if (initLibraryStatus !== prevProps.initLibraryStatus && !initLibraryStatus) {
      this.getDefaultPorts();
    }
  }

  getLibraryList = (libraries = []) => {
    let stateLibraries = {};

    if (libraries.includes(PCB_SPICE) || libraries.includes(PCB_TOUCHSTONE) || libraries.includes(GENERIC_SPICE) || libraries.includes(GENERIC_TOUCHSTONE)) {
      const pcbSpiceList = sierraLibrary.getTree(PCB_SPICE);
      const pcbTouchstoneList = sierraLibrary.getTree(PCB_TOUCHSTONE);
      const genericSpiceList = sierraLibrary.getTree(GENERIC_SPICE);
      const genericTouchstoneList = sierraLibrary.getTree(GENERIC_TOUCHSTONE);
      stateLibraries = {
        ...stateLibraries,
        pcbSpiceList,
        pcbTouchstoneList,
        genericSpiceList,
        genericTouchstoneList
      }
    }

    this.setState({
      ...stateLibraries
    })
  }

  getDefaultPorts = () => {
    const { model } = this.props;
    const { libraries, modelType } = model;
    const libraryIds = libraries.map(item => item.libraryId)
    this.getFileParse(libraryIds, modelType)
  }

  getCanvasWidth = (isReset, config) => {
    const { canvasConfig } = this.props;
    const _config = config ? config : canvasConfig;
    const actualHeightNum = _config && _config.height ? Number(_config.height) : 16;
    const actualHeight = (actualHeightNum + 3) * SCHEMATIC_GRID_SIZE;
    const actualWidthNum = _config && _config.width ? Number(_config.width) : 22;
    const actualWidth = (actualWidthNum + 7) * SCHEMATIC_GRID_SIZE;

    const offset = this.dialogRoot.getBoundingClientRect();

    this.setState({
      width: actualWidth > 1350 ? actualWidth : 1350,
      height: actualHeight,
      isReset,
      maxWidth: getPanelMaxWidth(offset, 770),
      maxHeight: getPanelMaxHeight(offset, 400),
    })
  }

  changeMode = (mode) => {
    this.props._changePreLayoutMode(mode);
  }

  selectModelType = (type) => {
    const { model, components } = this.props;
    let _components = [...components];
    _components = _components.map(comp => {
      let pins = comp.pins.map(pin => {
        return { ...pin, model: { libraryId: "", port: "", subckt: "" } }
      })
      return { ...comp, pins }
    })
    this.setState({
      lastOpenModel: {},
      portsObj: {}
    })
    this.props.saveModel({ ...model, modelType: type, libraries: [] }, _components, true);
    this.canvasRef && this.canvasRef.clearPinModel();
  }

  selectOpenModel = (libraryId, subckt) => {
    this.setState({
      lastOpenModel: {
        [libraryId]: subckt
      }
    })
  }

  getFilesParseList = (files) => {
    const promiseList = files.map(item => {
      if ([PCB_TOUCHSTONE, GENERIC_TOUCHSTONE].includes(item.type)) {
        return getTouchstoneParse(item.id, item.name);
      } else if ([PCB_SPICE, GENERIC_SPICE].includes(item.type)) {
        return getLibraryConnectorFile({ libraryId: item.id });
      }
      return null;
    }).filter(item => !!item);
    return Promise.all(promiseList);
  }

  getFileParse = async (files, modelType, isLibType) => {
    if (!files || files.length === 0) {
      return;
    }
    //filter libraryId not exist files
    let _files = []
    if (isLibType) {
      _files = files.map(f => sierraLibrary.checkFile(modelType, f)).filter(item => !!item);
    } else {
      let libType = modelType === SPICE ? [PCB_SPICE, GENERIC_SPICE] : [PCB_TOUCHSTONE, GENERIC_TOUCHSTONE];
      _files = files.map(f => sierraLibrary.checkFile(libType[0], f) || sierraLibrary.checkFile(libType[1], f)).filter(item => !!item);
    }
    const { portsObj } = this.state;
    let _portsObj = { ...portsObj }
    //get files ports
    const res = await this.getFilesParseList(_files);
    if (res && Array.isArray(res)) {
      _files.forEach((file, index) => {
        const libraryId = file.id;
        //update file portsObj
        const model = file.type.match(/spice/ig) ? [...(res[index] || [])] : (res[index] || {}).ports || [];
        _portsObj[libraryId] = model;
      });
      this.setState({
        portsObj: _portsObj
      })
    }
    return true;
  }

  onSelectLibrary = async (file, index) => {
    const { id, type } = file || {}
    const { model, components } = this.props;
    const { lastOpenModel, portsObj } = this.state;
    let _model = { ...model };
    let _components = JSON.parse(JSON.stringify(components));
    if (!_model.libraries[index]) {
      _model.libraries[index] = { libraryId: "", subckt: "" }
    }
    if (_model.libraries[index].libraryId) {
      let _lastOpenSubckt = lastOpenModel[_model.libraries[index].libraryId] ? {} : lastOpenModel
      _components = _components.map(comp => {
        let pins = comp.pins.map(pin => {
          if (pin.model && pin.model.libraryId === _model.libraries[index].libraryId && pin.model.subckt === _model.libraries[index].subckt) {
            return { ...pin, model: { libraryId: "", port: "", subckt: "" } }
          }
          return pin
        })
        return { ...comp, pins }
      })
      this.setState({
        lastOpenModel: _lastOpenSubckt
      })
      _model.libraries[index].subckt = "";
      this.canvasRef && this.canvasRef.clearPinModel([{ libraryId: _model.libraries[index].libraryId, subckt: _model.libraries[index].subckt || "" }]);
    }
    _model.libraries[index].libraryId = id;
    _model.libraries[index].subckt = "";
    if (!portsObj[id]) {
      await this.getFileParse([id], type, true)
    }

    if (_model.modelType === SPICE) {
      this.selectSingleSubckt(index, id, _components, _model);
    } else {
      this.props.saveModel(_model, _components, true);
    }
  }

  selectSingleSubckt = (index, id, _components, _model) => {
    const { portsObj } = this.state;
    let model = { ..._model };
    const subcktList = portsObj[id] ? portsObj[id].map(item => item.name) : [];
    if (subcktList.length === 1) {
      _model.libraries[index].subckt = subcktList[0];
    }
    this.props.saveModel(model, _components, true);
  }

  addNewFileSelect = (e) => {
    e && e.stopPropagation();
    const { model, components } = this.props;
    let _model = { ...model };
    if (!_model.libraries.length) {
      _model.libraries.push({ libraryId: "", subckt: "" });
    }
    _model.libraries.push({ libraryId: "", subckt: "" });
    this.props.saveModel(_model, components, false)
  }


  deleteModel = (e, index) => {
    e && e.stopPropagation();
    const { model, components } = this.props;
    let _model = { ...model };
    let saveToBackend = _model.libraries[index] && _model.libraries[index].libraryId ? true : false;
    let _components = JSON.parse(JSON.stringify(components));
    if (_model.libraries[index] && _model.libraries[index].libraryId) {
      _components = _components.map(comp => {
        let pins = comp.pins.map(pin => {
          if (pin.model && pin.model.libraryId === _model.libraries[index].libraryId
            && (_model.modelType === TOUCHSTONE || !pin.model.subckt || pin.model.subckt === _model.libraries[index].subckt)) {
            return { ...pin, model: { libraryId: "", port: "", subckt: "" } }
          }
          return pin
        })
        return { ...comp, pins }
      })
      this.canvasRef && this.canvasRef.clearPinModel([{ libraryId: _model.libraries[index].libraryId, subckt: _model.libraries[index].subckt || "" }]);
    }
    _model.libraries.splice(index, 1);
    this.props.saveModel(_model, _components, saveToBackend)
  }

  selectSubckt = (subckt, index) => {
    const { model, components } = this.props;
    let _model = { ...model };
    if (_model.libraries.map(item => item.subckt).includes(subckt)) {
      message.error('The current subckt has been selected!')
      return;
    }
    let _components = JSON.parse(JSON.stringify(components));
    if (_model.libraries[index] && _model.libraries[index].subckt) {
      _components = _components.map(comp => {
        let pins = comp.pins.map(pin => {
          if (pin.model && pin.model.libraryId === _model.libraries[index].libraryId && pin.model.subckt === _model.libraries[index].subckt) {
            return { ...pin, model: { libraryId: "", port: "", subckt: "" } }
          }
          return pin
        })
        return { ...comp, pins }
      })
      this.canvasRef && this.canvasRef.clearPinModel([{ libraryId: _model.libraries[index].libraryId, subckt: _model.libraries[index].subckt || "" }]);
    }
    if (!_model.libraries[index]) {
      return;
    }
    this.setState({
      lastOpenModel: {
        [_model.libraries[index].libraryId]: subckt
      }
    })
    _model.libraries[index].subckt = subckt;
    this.props.saveModel(_model, _components, true);
  }

  getCurrentList = () => {
    const { model } = this.props;
    const { libraries, modelType } = model;

    if (modelType === SPICE) {
      return libraries.filter(item => !!item).map(item => {
        const libraryInfo = sierraLibrary.checkFile(PCB_SPICE, item.libraryId) || sierraLibrary.checkFile(GENERIC_SPICE, item.libraryId) || {};
        return { ...libraryInfo, subckt: item.subckt }
      });
    } else if (modelType === TOUCHSTONE) {
      return libraries.filter(item => !!item).map(item => {
        const libraryInfo = sierraLibrary.checkFile(PCB_TOUCHSTONE, item.libraryId) || sierraLibrary.checkFile(GENERIC_TOUCHSTONE, item.libraryId) || {};
        return { ...libraryInfo }
      });
    }

    return [];
  }

  onRef = (ref) => {
    this.canvasRef = ref;
  }

  render() {
    const { loading, components, canvasUpdate, signals, id, canvasConfig, signalNumber, GPIO, libraryTreeInfo, mode, model, fixed, prelayout, differentialSections, initLibraryStatus, compTableLoading } = this.props;
    const { width, height, isReset, maxWidth, maxHeight, pcbSpiceList, pcbTouchstoneList, genericSpiceList, genericTouchstoneList, portsObj, lastOpenModel } = this.state;
    const currentList = this.getCurrentList();
    return <Fragment>
      <Spin spinning={loading || compTableLoading}>
        <div className="sierra-pre-layout-schematic-setup-title">
          <span className="font-bold sierra-setup-title-color">Setup</span>
          <Select
            placeholder="Select Mode"
            onChange={this.changeMode}
            value={mode}
            className="aurora-select"
            options={[
              { value: PRE_TEMPLATE, label: "Trace Template" },
              { value: PRE_MODEL, label: "Model" }
            ]}
          />
          {mode === PRE_MODEL ? <Tooltip
            title={<div>Click on the component to open the port assignment</div>}
            classNames={{ root: "icon-tooltip" }}>
            <InfoCircleOutlined className="sierra-pre-layout-schematic-info-icon" />
          </Tooltip> : null}
        </div>
        {mode === PRE_MODEL ? <div className="space-10">
          <ModelSelect
            width={100}
            model={model}
            spice={pcbSpiceList}
            touchstone={pcbTouchstoneList}
            genericSpice={genericSpiceList}
            genericTouchstone={genericTouchstoneList}
            selectModelType={this.selectModelType}
            onSelectLibrary={this.onSelectLibrary}
            addNewFileSelect={this.addNewFileSelect}
            deleteModel={this.deleteModel}
            fixed={fixed}
            portsObj={portsObj}
            selectSubckt={this.selectSubckt}
            prelayout={prelayout}
            initLibraryStatus={initLibraryStatus}
          />
        </div> : null}
        <Canvas
          id={id}
          onRef={this.onRef}
          canvasUpdate={canvasUpdate}
          loading={loading}
          width={width}
          height={height}
          maxWidth={maxWidth}
          maxHeight={maxHeight}
          isReset={isReset}
          signals={signals}
          components={components}
          signalNumber={signalNumber}
          differentialSections={differentialSections}
          GPIO={GPIO}
          canvasConfig={canvasConfig}
          mode={mode}
          libraryTreeInfo={libraryTreeInfo}
          lastOpenModel={lastOpenModel}
          model={model}
          fixed={fixed}
          portsObj={portsObj}
          libraries={currentList}
          updateSchematicLoading={this.props.updateSchematicLoading}
          updateComponents={this.props.updateComponents}
          updatePreLayoutData={this.props.updatePreLayoutData}
          updateCanvasStatus={this.props.updateCanvasStatus}
          updateCanvasConfig={this.props.updateCanvasConfig}
          getCanvasWidth={this.getCanvasWidth}
          _updateLibraryTree={this.props._updateLibraryTree}
          selectOpenModel={this.selectOpenModel}
        />
      </Spin>
    </Fragment>
  }
}

const mapState = (state) => {
  const { SierraReducer: {
    project: { viewList },
    prelayout: { components, schematicLoading, canvasUpdate, signals, id, canvasConfig, signalNumber, GPIO, differentialSections, mode, model, prelayout, compTableLoading },
    library: { libraryTreeInfo, initLibraryStatus }
  } } = state;
  return {
    components,
    loading: schematicLoading,
    compTableLoading,
    canvasUpdate,
    signals,
    id,
    viewList,
    canvasConfig,
    signalNumber,
    GPIO,
    libraryTreeInfo,
    mode,
    model,
    prelayout,
    differentialSections,
    initLibraryStatus
  }
}

const mapDispatch = (dispatch) => ({
  updateComponents(components) {
    dispatch(updateComponents(components))
  },
  updatePreLayoutData(info) {
    dispatch(updatePreLayoutData(info))
  },
  updateSchematicLoading(boolean) {
    dispatch(updateSchematicLoading(boolean))
  },
  updateCanvasStatus(boolean) {
    dispatch(updateCanvasStatus(boolean))
  },
  updateCanvasConfig(config) {
    dispatch(updateCanvasConfig(config))
  },
  _updateLibraryTree(type) {
    dispatch(updateLibraryTree(type))
  },
  _changePreLayoutMode(mode) {
    dispatch(changePreLayoutMode(mode))
  },
  saveModel(model, components, toBackend) {
    dispatch(saveModel(model, components, toBackend))
  }
})

export default connect(mapState, mapDispatch)(SchematicSetup);